export const SET_AVATAR = "SET_AVATAR";
export const SET_PUBLIC_AVATARS = "SET_PUBLIC_AVATARS";
export const SET_USER_AVATARS = "SET_USER_AVATARS";
export const CREATE_AVATAR = "CREATE_AVATAR";
export const AVATARS_RECEIVED = "AVATARS_RECEIVED";
export const SET_PROPERTY_AVATAR = "SET_PROPERTY_AVATAR";
export const SET_SUPER_FETCH_AVATAR = "SET_SUPER_FETCH_AVATAR";
export const SET_CONVERSATION_AVATAR = "SET_CONVERSATION_AVATAR";
